import { createPublicClient, http } from 'viem';
import { tracker } from 'utils/tracker';
import { baseSepolia, supportedChains } from 'configs/evm-chains';
export const getPublicClient = () => {
    const chainId = tracker.store.getState().selectedChainId;
    const selectedChain = supportedChains.find(chain => chain.id === chainId) || baseSepolia;
    if (!selectedChain) {
        throw new Error(`Unsupported chain ID: ${chainId}`);
    }
    return createPublicClient({
        chain: selectedChain,
        transport: http(),
    });
};
